<style scoped>
  td:nth-child(2), td:nth-child(3), td:nth-child(5), td:nth-child(6), td:nth-child(7)  {
    text-align: left
    }
  td:nth-child(1) {
      text-align: right
  }
  td:nth-child(4), td:nth-child(8) {
      text-align: center
  }
  td[colspan="7"] {
    text-align: center
  }
  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .windy { color: red; font-style: italic; }
  .windOK { color: green; font-style: italic; }
  @media (max-width:767px) {
    .table td, .table th {
      padding-left: 2px !important; padding-right: 2px !important
    }
  }
</style>

<template>
  <div>
    <div :class="'card bg-steel mb-2' + (isSmallSearchVisible?'': ' d-none d-lg-flex')" id="searchBox">
      <form class="card-body form form-inline filter-form">
        <select class="form-control" name="gender" v-model="dataGender" @change="cfilter">
          <option v-for="option in genders" :value="option.value">{{ option.text }}</option>
        </select>
        <select class="form-control" name="year" v-model="dataYear" @change="cfilter">
          <option v-for="code in periods" :value="code[0]">{{ code.length==2 ? trans(code[1]) : code[0] }}</option>
        </select>
        <select class="form-control" name="agegroup" placeholder="agegroup" v-model="dataAgeGroup" @change="cfilter">
            <option v-for="code in ageGroups" :value="code[0]">{{ code.length==2 ? trans(code[1]) : code[0] }}</option>
          </select>
          <select class="form-control" name="indoor" placeholder="I/O" v-model="dataIndoor" @change="cfilter">
          <option value="0">{{ trans('Outdoor') }}</option>
          <option value="1">{{ trans('Indoor') }}</option>
        </select>
        <select v-if="eventCodes.length > 0" class="form-control" name="event" placeholder="event" v-model="dataEvent" @change="cfilter($event,1)">
        <option v-for="code in eventCodes" :value="code[0]">{{ code[2] }}</option>
          </select>
        <button type="button" @click="loadTilastopaja()" :class="'ml-auto btn btn-primary border-0' + (state==0?' disabled':'')">{{ trans((state==2)?'Get Rankings': 'Get Events') }}</button>
      </form>
    </div>
    <form class="form form-horizontal form-inline">
    </form>
    <h3>{{ current.country }} {{ current.year }} {{ current.event }} {{ current.indoor }} {{ current.gender }}</h3>
    <table class="table table-condensed bg-white" bg-white v-if="goodResponse" :style="'opacity: '+table_opacity()">
      <thead>
        <tr class="bg-blue">
          <th>#</th>
          <th>{{ trans('Result') }}</th>
          <th>{{ trans('Athlete') }}</th>
          <th>{{ trans('Born') }}</th>
          <th class="d-none d-lg-table-cell">{{ trans('Club') }}</th>
          <th>{{ trans('Venue') }}</th>
          <th class="d-none d-lg-table-cell">{{ trans('Competition') }}</th>
          <th class="d-none d-lg-table-cell">{{ trans('Cat')}}</th>
          <th>{{ trans('Date') }}</th>
        </tr>
      </thead>
      <tbody v-if="typeof expandedRankings[0] !== 'undefined'">
        <tr v-for="(perf, i) in expandedRankings">
          <td v-if="perf.rank">{{ perf.rank }}</td>
          <td v-else v-if="perf.combinedPerformances" class="d-none d-md-table-cell py-1" style="border-top: 1px #FFF solid" :ref="'row' + i"></td>
          <td v-if="perf.combinedPerformances" class="d-none d-md-table-cell bg-light py-1" colspan="5" style="font-size: .9em; letter-spacing:-.01rem">
            <span v-for="p in formattedPerformances(perf.combinedPerformances)" class="d-inline-block my-0 py-0 mx-1">{{ p.value }}<i v-if="p.wind" class="text-muted">({{ p.wind }})</i></span>
          </td>
          <td v-if="perf.combinedPerformances" class="d-table-cell d-md-none bg-light py-1" colspan="6" style="font-size: .9em; letter-spacing:-.01rem">
            <span v-for="p in formattedPerformances(perf.combinedPerformances)" class="d-inline-block my-0 py-0 mx-1">{{ p.value }}<i v-if="p.wind" class="text-muted">({{ p.wind }})</i></span>
          </td>
          <td v-if="perf.rank">
              {{ perf.performance }}
              <span v-if="perf.wind" :class="parseFloat(formatWind(perf.wind)) > 2.0 ? 'windy' : 'windOK'"> ({{ formatWind(perf.wind, true) }})</span>
          </td>
          <td v-if="perf.rank"><a v-if="perf.otAthleteId !== '' || perf.tpAthleteId !== ''" :href="personHref(perf)"><i>{{ perf.givenName }}</i> <b>{{ perf.familyName }}</b></a>
            <span v-else><i>{{ perf.givenName }}</i> <b>{{ perf.familyName }}</b></span>
          </td>
          <td v-if="perf.rank"> <span v-if="perf.birthDate" class="text-muted">{{ showBirth(perf.birthDate) }}</span></td>
          <td v-if="perf.rank" class="d-none d-lg-table-cell club">
            <a v-if="perf.club !== '' && perf.club && perf.club.toLowerCase" :href="'/orgs/' + perf.club.toLowerCase() ">{{ perf.club }}</a>
            <span v-else>{{ perf.club }}</span>
          </td>
          <td v-if="perf.rank" :rowspan="expandedRankings.length > i && expandedRankings[i+1].hasOwnProperty('combinedPerformances') ? 2 : 1">{{ perf.cityName }}</td>
          <td v-if="perf.rank" :rowspan="expandedRankings.length > i && expandedRankings[i+1].hasOwnProperty('combinedPerformances') ? 2 : 1" class="d-none d-lg-table-cell ellipsis" style="width:200px">{{ perf.info }}</td>
          <td  v-if="perf.rank" :rowspan="expandedRankings.length > i && expandedRankings[i+1].hasOwnProperty('combinedPerformances') ? 2 : 1" class="d-none d-lg-table-cell"><b>{{ perf.waCompCategory }}</b></td>
          <td v-if="perf.rank" class="pr-0">
            <span class="d-inline-block d-lg-none mr-0 pr-0 text-nowrap">{{ dataYear !== "ALLT" ? perf.date.substr(5) : new Date(perf.date).toLocaleDateString() }}</span>
            <span class="d-none d-lg-inline-block">{{ new Date(perf.date).toLocaleDateString() }}</span>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
         <tr><td colspan="8"><b><i>{{ trans ('No data') }}</i></b></td></tr>
      </tbody>
    </table>

    <div v-if="errorMessage" class="alert alert-danger">
      <p>{{ errorMessage }}</p>
    </div>
    <p v-if="goodResponse" class="d-none d-lg-block"><a :href="directUrl()">{{ trans('Direct URL') }}: {{directUrl()}}</a></p>
    <div v-if="isAdmin">
        <p v-if="jsonUrl"><a :href="jsonUrl">&lt;raw rankings data&gt;</a></p>
        <p v-if="jsonUrlEvents"><a :href="jsonUrlEvents">&lt;raw events data&gt;</a></p>
    </div>
    <slot></slot>
  </div>
</template>


<script>
import _ from 'lodash'
import { sorts, encodeQueryData } from '../utils'
import TranslationMixin from '../assets/TranslationMixin.js'

export default {
  mixins: [TranslationMixin],
  props: {
    indoor: {
      type: String,
      default: '0'
    },
    isAdmin: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    forceVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    year: {
      type: String,
      validator: function (value) {
        if (isNaN(parseInt(value))) {
          return value === 'ALLT'
        } else {
          var v = parseInt(value)
          return v > 1900 && v <= new Date().getFullYear()
        }
      }
    },
    country: {
      type: String,
      validator: function (value) {
        return value.length === 3 || value.length === 2
      },
      default: 'EST'
    },
    version: {
      type: Number,
      default: 1
    },
    showDob: {
      type: Number,
      default: 0
    },
    tilastopajaDomain: {
      type: String
    },
    gender: {
      type: String,
      validator: function (value) {
        return ['W', 'M'].indexOf(value.toUpperCase()) >= 0
      },
      default: 'M'
    },
    agegroup: {
      type: String,
      default: 'SEN'
    },
    event: String,
    periods: { type: Array, default: function () { return [['ALLT', 'all time'], ['2018'], ['2017']] } },
    ageGroups: { type: Array, default: function () { return [['SEN', 'Senior'], ['U23'], ['U20'], ['U18'], ['U16'], ['U14']] } }
  },
  data () {
    return {
      genders: [],
      dataYear: (new Date().getFullYear()) + '',
      dataEvent: '',
      dataAgeGroup: '',
      dataCountry: '',
      dataGender: '',
      dataIndoor: '0',
      est_date_pattern: /\d{2}\.\d{2}\.\d{4}/,
      rankings: [],
      eventCodes: [],
      dummy: '',
      sortKey: '',
      sortWays: [],
      sortKeys: [],
      tilpa: {},
      current: {},
      goodResponse: false,
      error: null,
      messages: {},
      jsonUrl: '',
      isSmallSearchVisible: false,
      loadingState: false,
      currentAthleteId: '',
      jsonUrlEvents: ''
    }
  },
  methods: {
    showBirth: function (dateString) {
      var self = this
      if (self.showDob === 1) {
        return new Date(dateString).toLocaleDateString()
      } else {
        return dateString.slice(0, 4)
      }
    },
    formattedPerformances: function (perfs) {
      var out = []
      _.each(perfs.split(' '), function (p) {
        var splt = p.split('/')
        var row = {value: splt[0]}
        if (splt.length > 1) {
          row.wind = splt[1]
        }
        out.push(row)
      })
      return out
    },
    floatSort: function (obj) {
      if (obj.result) {
        obj.result_num = parseFloat(obj.result)
      } else {
        obj.result_num = 0
      }
      if (obj.rank) {
        obj.rank_num = parseFloat(obj.rank)
      } else {
        obj.rank_num = 0
      }
    },
    obj2EC: function (obj) {
      return [obj.eventCode, obj.event, obj.eventName]
    },
    populateState: function () {
      var s = this
      var r = {
        gender: s.dataGender === 'W' ? s.trans('Women') : s.trans('Men'),
        year: s.dataYear,
        country: s.country,
        indoor: s.dataIndoor === '1' ? s.trans('Indoor') : s.trans('Outdoor'),
        agegroup: s.dataAgeGroup
      }
      try {
        r.event = _.find(sorts.FIELDS, function (row) { return row[0] === s.dataEvent })[2]
      } catch (e) { }
      return r
    },
    windy: function (wind) {
      return (parseFloat(wind) > 2.0)
    },
    formatWind: function (wind, includePlus = false) {
      wind = wind.replace('++', '')
      wind = wind.replace('+', '')

      if (includePlus && parseFloat(wind) > 0) wind = '+' + wind

      // brackets, red if illegale
      return wind
    },
    setCurrent: function () {
      var self = this
      var url = ''
      self.current = self.populateState()
      if (!self.loadingState) {
        url = self.directUrl().substr(self.directUrl().indexOf('/ranking/'))
        window.history.pushState(self.getCurrent(), self.current.country + ' ' + self.current.year + ' ' + self.current.event + ' ' + self.current.indoor + ' ' + self.current.gender, url)
      } else {
        self.loadingState = false
      }
      self.isSmallSearchVisible = false
    },
    isSameFilterSet: function () {
      var self = this
      var t = self.populateState()
      var c = self.current
      var F = ['event', 'country', 'year', 'gender', 'agegroup', 'indoor']
      var f
      for (var i = 0; i < F.length; i++) {
        f = F[i]
        if (c[f] !== t[f]) return false
      }
      return true
    },
    eventsUrl: function () {
      var self = this
      var q = { gender: self.dataGender, season: self.dataYear.toLowerCase(), ag: self.dataAgeGroup.toUpperCase(), country: self.country.toLowerCase(), ind: self.dataIndoor }
      var url = '//' + self.tilastopajaDomain + '/json/eventsAPI.php'
      if (q.ag === 'SEN') delete q.ag
      return url + '?' + encodeQueryData(q)
    },
    loadEvents: function (cb) {
      var self = this
      if (self.state >= 1) {
        var url = self.eventsUrl()
        self.jsonUrlEvents = ''
        self.$http.get(url, {}).then((response) => {
          self.dummy = 'raw data'
          return response.json()
        }).then((data) => {
          self.dummy = 'json data'
          data = self.cleanTilpaData(data)
          if (!Array.isArray(data)) data = [data]
          self.eventCodes = []
          data.forEach(function (d) {
            var events = d.hasOwnProperty('events') ? d.events.map(self.obj2EC) : []
            events.forEach(function (ev) {
              // if (self.eventCodes.filter(function (ec) { return ec[1] === ev[1] }).length === 0) {
              self.eventCodes.push(ev)
              // }
            })
          })
          if (self.eventCodes.length >= 1) {
            self.dataEvent = self.eventCodes[0][0]
            self.error = null
            if (cb) {
              cb()
            }
          } else {
            self.error = 'No events were seen in the data'
          }
          self.jsonUrlEvents = url
        }).catch((error) => {
          self.error = error
          self.eventCodes = []
        })
      }
    },
    rankingsUrl: function () {
      var self = this
      var url
      var q = { gender: self.dataGender, season: self.dataYear.toLowerCase(), ind: self.dataIndoor, event: self.dataEvent, ag: self.dataAgeGroup.toUpperCase(), country: self.country.toLowerCase() }
      if (q.ag === 'SEN') {
        delete q.ag
      }
      url = '//' + self.tilastopajaDomain + '/json/listApi.php'
      return url + '?' + encodeQueryData(q)
    },
    loadRankings: function () {
      var self = this
      if (self.state === 2) {
        var url = self.rankingsUrl()
        self.jsonUrl = ''
        self.$http.get(url, {}).then((response) => {
          self.dummy = 'raw data'
          return response.json()
        }).then((data) => {
          self.dummy = 'json data'
          data = self.cleanTilpaData(data)
          self.tilpa = data
          if (data.hasOwnProperty('ranking')) {
            self.rankings = data.ranking
            _.each(self.rankings, self.floatSort)
          }
          self.jsonUrl = url
          self.goodResponse = true
          self.error = null
          self.setCurrent()
        }).catch((error) => {
          self.error = error
          self.goodResponse = false
        })
      }
    },
    loadTilastopaja: function (cb) {
      var self = this
      if (self.state === 1) {
        self.loadEvents(cb)
      } else if (self.state === 2) {
        self.loadRankings()
      }
    },
    cleanTilpaData: function (obj, keysToRename) {
      if (typeof keysToRename === 'undefined') {
        keysToRename = {}
      }
      var isArray = Array.isArray

      function cleanObject (o) {
        var build, key, destKey, value
        build = {}
        for (key in o) {
          destKey = keysToRename[key] || key
          value = o[key]
          if (value === null) {
            value = ''
          } else if (typeof value === 'object') {
            value = isArray(value) ? value.map(cleanObject) : cleanObject(value)
          }
          build[destKey] = value
        }
        return build
      }
      return isArray(obj) ? obj.map(cleanObject) : cleanObject(obj)
    },
    cfilter: function (e, n) {
      var self = this
      if (!n) {
        var sev = e.target.form.event
        if (sev) {
          sev.selectedIndex = -1
          sev.value = ''
        }
        self.dataEvent = ''
        self.eventCodes = []
        self.jsonUrl = ''
        self.jsonUrlEvents = ''
      }
    },
    table_opacity: function () {
      var self = this
      return self.isSameFilterSet() ? '1.0' : '0.5'
    },
    getCurrent: function () {
      var self = this
      return {
        gender: self.dataGender,
        agegroup: self.dataAgeGroup,
        year: self.dataYear,
        indoor: self.dataIndoor,
        event: self.dataEvent
      }
    },
    directUrl: function () {
      var self = this
      var u = [window.location.protocol, '//', window.location.host, window.location.pathname].join('')
      return u + '?' + encodeQueryData(self.getCurrent())
    },
    personHref: function (p) {
      return (p.otAthleteId ? '/people/' + p.otAthleteId : '/person_tilpa/' + p.tpAthleteId) + '/'
    },
    loadState: function (src) {
      var self = this
      if (src.year) self.dataYear = src.year
      if (src.country) self.dataCountry = src.country
      if (src.gender) self.dataGender = src.gender.toUpperCase()
      if (src.agegroup) self.dataAgeGroup = src.agegroup
      if (src.indoor) self.dataIndoor = src.indoor === '1' ? '1' : '0'
      if (src.event) {
        self.loadTilastopaja(function () {
          for (var i = 0; i < self.eventCodes.length; i++) {
            if (self.eventCodes[i][0] === src.event) {
              self.dataEvent = src.event
              self.loadTilastopaja()
              return
            }
          }
        })
      }
    }
  },
  computed: {
    sortedRankings: function () {
      var self = this
      return self.sortedList(self.rankings, self.sortKeys)
    },
    expandedRankings: function () {
      var self = this
      var out = []
      _.each(self.rankings, function (r) {
        var row2 = {}
        if (r.hasOwnProperty('combinedPerformances')) {
          if (r.combinedPerformances.trim().length > 0) {
            row2 = {combinedPerformances: r.combinedPerformances}
          }
          delete r.combinedPerformances
        }
        out.push(r)
        if (row2) {
          out.push(row2)
        }
      })
      return out
    },
    state: function () {
      var self = this
      var s = 0
      if (self.dataGender && self.dataCountry && self.dataAgeGroup && self.dataYear && self.dataIndoor && self.dataEvent) s = 2
      else if (self.dataGender && self.dataCountry && self.dataAgeGroup && self.dataYear && self.dataIndoor) s = 1
      return s
    },
    errorMessage: function () {
      var self = this
      var msg = ''
      if (self.error) {
        if (self.error.statusText) {
          msg = self.error.statusText
        } else {
          msg = self.error.toString()
          if (msg.indexOf('SyntaxError') > -1) {
            msg = self.trans('Error processing data!')
          }
        }
        return '! ' + msg
      } else {
        return ''
      }
    }
  },
  created: function () {
    var self = this
    self.loadState(self)
    if (self.forceVisible) self.isSmallSearchVisible = true
    window.onpopstate = function (e) {
      self.loadingState = true
      self.state = 2
      if (window.history.state) self.loadState(window.history.state)
    }
  },
  mounted: function () {
    var self = this
    self.genders = [{value: 'M', text: self.trans('Men')}, {value: 'W', text: self.trans('Women')}]
  }
}
</script>



// WEBPACK FOOTER //
// Rankings.vue?698424b0